import { Link } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';

const SiteFooter = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-[#1f2024] mt-16 py-10 px-4 text-center" data-testid="site-footer">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-white/70">
          <Link to="/about" className="hover:text-[#ff4e15] transition-colors">{t('aboutUs')}</Link>
          <Link to="/privacy-policy" className="hover:text-[#ff4e15] transition-colors">{t('privacyPolicy')}</Link>
          <Link to="/terms" className="hover:text-[#ff4e15] transition-colors">{t('termsConditions')}</Link>
          <Link to="/refund-policy" className="hover:text-[#ff4e15] transition-colors">{t('refundPolicy')}</Link>
          <Link to="/shipping-return" className="hover:text-[#ff4e15] transition-colors">{t('shippingReturn')}</Link>
          <Link to="/contact" className="hover:text-[#ff4e15] transition-colors">{t('contactUs')}</Link>
        </div>
        <p className="mt-6 text-xs text-white/50">{t('footerRights')}</p>
        <p className="mt-1 text-xs text-white/40">{t('footerDisclaimer')}</p>
      </div>
    </footer>
  );
};

export default SiteFooter;
